window.Products.Clothing.BabyLeggings3years = function() {};

window.Products.Clothing.BabyLeggings3years.inherits(window.Products.Clothing.BabyLeggings);
window.Products.Clothing.BabyLeggings3years.has_3d = true;
window.Products.Clothing.BabyLeggings3years.id = '27-3years';
window.Products.Clothing.BabyLeggings3years.saveId = 27;
window.Products.Clothing.BabyLeggings3years.slug = 'baby-leggings-3years';
window.Products.Clothing.BabyLeggings3years.dpi = 150;